import { tv } from "tailwind-variants";

// Implements https://piccalil.li/blog/accessible-faux-nested-interactive-controls/
// Good for accessibility but also to avoid React errors about illegally nesting of <button> and such
export const baseNestedControlsStyle = tv({
  slots: {
    container: "relative cursor-pointer",
    primaryControl:
      "before:absolute before:inset-0 before:block before:content-['']",
    secondaryControl: "relative z-10",
  },
});

export const nestedControlsStyle = baseNestedControlsStyle();
